import { Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { RequireAuth } from './components/RequireAuth';
import { BootCheck } from './pages/BootCheck';
import { Login } from './pages/Login';
import { Overview } from './pages/Overview';
import { Placeholder } from './pages/Placeholder';
import { Users } from './pages/Users';
import { Engagement } from './pages/Engagement';
import { Content } from './pages/Content';
import { Moderation } from './pages/Moderation';
import { Posts } from './pages/Posts';
import { Health } from './pages/Health';

function Protected({ element }: { element: JSX.Element }): JSX.Element {
  return (
    <RequireAuth>
      <AppShell>{element}</AppShell>
    </RequireAuth>
  );
}

export function App(): JSX.Element {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/boot" element={<BootCheck />} />
      <Route path="/" element={<Protected element={<Overview />} />} />
      <Route path="/users" element={<Protected element={<Users />} />} />
      <Route path="/engagement" element={<Protected element={<Engagement />} />} />
      <Route path="/content" element={<Protected element={<Content />} />} />
      <Route path="/moderation" element={<Protected element={<Moderation />} />} />
      <Route path="/posts" element={<Protected element={<Posts />} />} />
      <Route path="/health" element={<Protected element={<Health />} />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
